import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { classNames, ddayjs } from '@dt/fe-utils'
import {
  menuMobx,
  cartMobx,
  storeMobx,
  restaurantConfig,
} from 'restaurant'
import { timePickMobx, decorationMobx, deliveryMobx } from '@mobxStore'
import { Input } from '@cps'
import { modalLayer, handleEleScrollTo } from '@utils'
import CashierController from 'controllers/cashierController'
import CategoryBar from '../ProductTemplate/CategoryBar'
import { SearchModal } from '../../modal'
import './index.scss'

let timer = null
const timeSlice = (str) => {
  const nowTime = ddayjs(ddayjs().format('YYYY-MM-DD HH:mm')).valueOf()
  const chooseTime = ddayjs(`${ddayjs().format('YYYY-MM-DD')} ${str}`).valueOf()
  return (chooseTime - nowTime) / 1000
}

const secondsToTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const second = Math.floor(seconds % 60)
  return `${minutes ? i18n.t('common.minutes', { time: minutes }) : ''}${
    second ? i18n.t('common.seconds', { time: second }) : ''
  }`
}

interface IProps {
  gotoVoiceServicePage?: () => void;
}

const MenuHeader: React.FC<IProps> = (props) => {
  const [showTip, setShowTip] = useState('')

  const handleSelectCategory = function (no?: string) {
    menuMobx.selectCategory(no)
    const menuListContent = document.querySelector('.product-template') as any
    let offsetTop = menuListContent?.offsetTop || 0
    if (offsetTop >= decorationMobx.menuHeaderHeight) {
      offsetTop = offsetTop - decorationMobx.menuHeaderHeight
    }
    handleEleScrollTo?.({ y: offsetTop })
    setTimeout(() => {
      decorationMobx.setSearchBarVisible(false)
    }, 300)
  }

  const handleShowSearch = () => {
    modalLayer(SearchModal, {
    }).then((product: any) => {
      CashierController.showProductDetail(product)
      menuMobx.setSearchKey('')
    }).catch((e) => {
      menuMobx.setSearchKey('')
      if (e === 'microphone') {
        props.gotoVoiceServicePage && props.gotoVoiceServicePage()
      }
    })
  }

  useEffect(() => {
    const { pickDayIndex, pickTime } = timePickMobx.selectedInfo
    timer && clearInterval(timer)
    const showTip = cartMobx?.info?.eatType === 'delivery' ? !!deliveryMobx.address : true
    const prepareTime = (storeMobx.info?.preparationTime?.[0]?.time?.data === 0 ? 0 : (storeMobx.info?.preparationTime?.[0]?.time?.data || 0)) * 60
    const expressTime = (cartMobx?.info?.eatType === 'delivery' ? deliveryMobx.expressTime || 0 : 0) * 60
    const isReset = pickTime && (timeSlice(pickTime) !== expressTime + prepareTime)
    if (pickDayIndex === 0 && isReset && showTip) {
      // 2022.03.11去掉+3
      let restTime = timeSlice(pickTime) - expressTime - prepareTime
      timer = setInterval(() => {
        restTime -= 1
        // 只剩3分钟开始倒计时
        if (restTime <= 180) {
          // 注释2022.07.08
          // setShowTip(secondsToTime(restTime))
        } else {
          setShowTip('')
        }
        if (restTime <= 0) {
          setShowTip('')
          // timePickMobx.reset(true)
          timer && clearInterval(timer)
        }
      }, 1000)
    } else {
      setShowTip('')
    }
  }, [timePickMobx.selectedInfo])

  const SearchInput = () => (
    <div className='header-search-input'>
      <div className='search-wrap'>
        <Input
          icon='iconfont icon-search'
          placeholder={i18n.t('menu.search_product')}
          value={menuMobx.searchKey || ''}
          onFocus={handleShowSearch}
          onChange={(e) => {
            menuMobx.setSearchKey(e.target.value)
          }}
        />
      </div>
    </div>
  )

  const listClassicSearchRender = (
    <div className={`header-search${showTip ? ' has-tip' : ''}`}>
      <SearchInput />
      {restaurantConfig.displayMode === 'list' && <CategoryBar useHeader />}
    </div>
  )

  const waterfallRender = (
    <div
      className={`header-search category-list-warapper ${
        showTip ? ' has-tip' : ''
      }`}
    >
      <span className='category-list-item' onClick={handleShowSearch}>
        <i className='iconfont icon-search'></i>
      </span>
      {
        menuMobx.selectCategoryNo && <span className='category-list-item' onClick={() => handleSelectCategory()}>{i18n.t('common.all')}</span>
      }
      {menuMobx.categories.map((item) => (
        <span key={item.no} className={`category-list-item${menuMobx.selectCategoryNo === item.no ? ' active' : ''}`} onClick={() => handleSelectCategory(item.no)}>
          {item.name}
        </span>
      ))}
    </div>
  )

  return (
    <>
      <div
        className={classNames('menu-header-container', {
          'show-botton-line': decorationMobx.menuScrollTop > 10, // showBottomLine,
          'show-search': decorationMobx.searchBarVisible,
          'show-category': decorationMobx.headerCategoryBarVisible,
          'close-animation': decorationMobx.menuScrollTop < 50,
          'show-tip': showTip,
        })}
      >
        {showTip && (
          <div className='menu-header-tip'>
            {i18n.t('menu.menuOrderTip', { time: showTip })}
          </div>
        )}
        {/* {restaurantConfig.displayMode === 'list' ||
        restaurantConfig.displayMode === 'classic'
          ? listClassicSearchRender
          : waterfallRender} */}
      </div>
    </>
  )
}

export default observer(MenuHeader)
